import type { ConfigType } from '@plone/registry';

export default function install(config: ConfigType) {
  // Main
  config.settings.siteLabel = 'Plone Conference 2026';

  // Language settings
  config.settings.isMultilingual = false;
  config.settings.supportedLanguages = ['en'];
  config.settings.defaultLanguage = 'en';

  // Display Plone Login Form
  config.settings.showPloneLogin = true;
  // Navigation
  config.settings.navDepth = 3;

  // Matomo
  config.settings.matomoSiteId = '17';
  config.settings.matomoUrlBase = 'https://stats.ploneconf.org/';

  return config;
}
